import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 访客列表
  visitorList(data) {
    const params = data
    return request({
      url: urlParams + '/visitor-record/list',
      type: 'get',
      params: params
    })
  },
  // 访客登记列表
  visitorCodeList(data) {
    const params = data
    return request({
      url: urlParams + '/visitor-qr-code/list',
      type: 'get',
      params: params
    })
  },  
  // 访客登记新增
  visitorCodeAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/visitor-qr-code/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 访客登记删除
  visitorCodeDel(data) {
    const params = data
    return request({
      url: urlParams + '/visitor-qr-code/del',
      type: 'post',
      params: params
    })
  },    
  // 访客登记生成二维码
  visitorCodeGenerateQrCode(data) {
    const params = data
    return request({
      url: urlParams + '/visitor-qr-code/generateQrCode',
      type: 'post',
      params: params
    })
  },    
  // 消息列表
  messageList(data) {
    const params = data
    return request({
      url: urlParams + '/message/list',
      type: 'get',
      params: params
    })
  },
  // 消息新增
  messageAdd(data) {
    const params = data
    return request({
      url: urlParams + '/message/add',
      type: 'post',
      params: params,
      qs: false
    })
  },
  // 消息删除
  messageDel(data) {
    const params = data
    return request({
      url: urlParams + '/message/del',
      type: 'post',
      params: params
    })
  },
  messageDetail(data) {
    const params = data
    return request({
      url: urlParams + '/message/detail',
      type: 'get',
      params: params
    })
  },
}